module.exports = __webpack_public_path__ + "fonts/Repsol-Regular.0511df98.ttf";